<template>
  <div>
    <v-menu v-model="picker" content-class="elevation-2" :close-on-content-click="false" offset-y>
      <v-text-field slot="activator" :height="height" :value="displayedValue" :label="label" :rules="rules" readonly></v-text-field>
      <v-card>
        <v-card-text class="pa-0">
          <v-layout>
            <v-flex xs6>
              <v-date-picker @input="setDate($event)" :value="date" class="elevation-0"></v-date-picker>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex xs6>
              <v-time-picker @input="setTime($event)" :value="time" class="elevation-0" format="24hr"></v-time-picker>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'datetime-picker',

  props: ['value', 'label', 'height', 'rules'],

  data() {
    let val = this.value == '' ? null : this.value
    return {
      date: val != null ? val.split('T')[0] : null,
      time: val != null ? val.split('T')[1].slice(0, 5) : '00:00',
      picker: false
    }
  },

  watch: {
    picker (newVal) {
      if (newVal == false) {
        this.activeTab = 0
      }
    }
  },

  computed: {
    displayedValue () {
      return this.value != null ? this.value.replace('T', ' ').slice(0, 16) : null
    }
  },

  methods: {

    setDate (val) {
      this.date = val
      this.sync()
    },

    setTime (val) {
      this.time = val
      this.sync()
    },

    sync () {
      let val = this.date != null ? `${this.date}T${this.time}:00Z` : null
      this.$emit('input', val)
    }

  }
}
</script>
